import { ITemplate } from 'entities/template/template';
import { TemplateManagementRoute } from 'sections/design/template-management/routes';
import { TemplateTypes } from '../../../constants/templateTypes';

export const getEditRoute = (selectedTemplate: ITemplate): string => {
  if (selectedTemplate.type === TemplateTypes.unsubscribeEmailTracking) {
    return TemplateManagementRoute.EDIT_EMAIL_TRACKING_UNSUBSCRIBE;
  }
  if (selectedTemplate.type === TemplateTypes.unsubscribe) {
    return TemplateManagementRoute.EDIT_UNSUBSCRIBE;
  }
  if (selectedTemplate.channel === 'onsite') return TemplateManagementRoute.EDIT_ONSITE;
  if (selectedTemplate.channel === 'rcs') return TemplateManagementRoute.EDIT_RCS;
  return TemplateManagementRoute.EDIT;
};
